<style
  scoped
  type="text/css"
>
.filter-dialog-test {
  padding: 50px;
}
</style>
<template>
  <div class="filter-dialog-test">

    <p>Titulo</p>
    <el-input v-model="title"/>

    <p>Configuração</p>
    <el-input
      v-model="inputText"
      rows="10"
      type="textarea"
    ></el-input>
    <p
      v-if="inputParseError"
      style="color: red"
    >{{ inputParseError }}</p>

    <p>Saida</p>
    <el-input
      v-model="outputText"
      rows="10"
      type="textarea"
    ></el-input>
    <p
      v-if="outputParseError"
      style="color: red"
    >{{ outputParseError }}</p>

    <br>
    <el-button
      style="margin-top: 20px;"
      type="primary"
      @click="showDialog = true"
    >click to open the Dialog
    </el-button>

    <filterDialog
      :componentList="inputJson"
      :open.sync="showDialog"
      :output.sync="outputJson"
      :title="title"
    />
  </div>
</template>

<script>
import FilterDialog from '@/components/filterDialog/FilterDialog'
import filterConfig from './filterConfig.json'

export default {
  name: 'FilterDialogTest',
  components: { FilterDialog },
  computed: {
    inputParseError () {
      try {
        JSON.parse(this.inputText)
        return false
      } catch (error) {
        return error.message
      }
    },
    outputParseError () {
      try {
        JSON.parse(this.outputText)
        return false
      } catch (error) {
        return error.message
      }
    },
    inputJson () {
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    },
    outputText () {
      try {
        return JSON.stringify(this.outputJson, null, 2)
      } catch (ignored) {
        return '{}'
      }
    }
  },
  data () {
    return {
      title: 'Filtros',
      inputText: JSON.stringify(filterConfig, null, 2),
      outputJson: {},
      showDialog: false
    }
  }
}
</script>
